import styled from 'styled-components';

export const Icon = styled.svg`
	width: 30px;
	height: 30px;
	transition: fill 0.2s;
	fill: ${(props) => props.theme.darkGrayColor};
	stroke: none;
`;

export const Root = styled.button`
	display: inline-block;
	padding: 0;
	color: ${(props) => props.isActive && props.theme.primaryColor};
	background-color: transparent;
	border: none;
	cursor: pointer;

	${Icon} {
		fill: ${(props) => (props.isActive ? props.theme.primaryColor : props.theme.middleGrayColor)};
	}

	@media (min-width: 992px), (pointer: none) {
		&:hover {
			${Icon} {
				fill: ${(props) => props.theme.primaryColor};
			}
		}
	}
`;

export const Lexs = styled(Root)`
	display: flex;
	background-color: ${(props) => props.isActive && '#f8e71c'};
	transition: ${(props) => props.isActive && 'background-color 0.2s ease'};

	${Icon} {
		width: 15px;
		height: 14px;
		stroke-width: 2px;
		fill: #000;

		@media (pointer: none) {
			&:hover {
				fill: #000;
			}
		}
	}

	@media (pointer: none) {
		&:hover {
			${Icon} {
				fill: #000;
			}
		}
	}
`;
